(() => {
  const mounted = new WeakMap();
  const mount = (root) => {
    if (mounted.has(root)) return;
    const slides = [...root.querySelectorAll('[data-cs-slide]')];
    if (slides.length < 2) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const controls = root.querySelector('[data-cs-controls]');
    const toggle = root.querySelector('[data-cs-toggle]');
    const position = root.querySelector('[data-cs-position]');
    const surface = root.querySelector('[data-cs-slides]');
    let index = 0, timer, visible = false, hovered = false;
    let playing = root.dataset.autoplay === 'true' && !motion.matches;
    let start = null, suppressClick = false;
    const listeners = [];
    const on = (node, event, callback, options) => {
      node.addEventListener(event, callback, options);
      listeners.push(() => node.removeEventListener(event, callback, options));
    };
    const schedule = () => {
      clearTimeout(timer);
      if (playing && visible && !hovered && !document.hidden && !motion.matches) {
        timer = setTimeout(() => { index = (index + 1) % slides.length; render(); }, 7000);
      }
    };
    const render = () => {
      slides.forEach((slide, i) => {
        slide.hidden = false;
        slide.inert = i !== index;
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.classList.toggle('is-active', i === index);
      });
      position.textContent = `${index + 1} / ${slides.length}`;
      position.setAttribute('aria-live', playing ? 'off' : 'polite');
      toggle.textContent = playing ? root.dataset.pauseLabel : root.dataset.playLabel;
      toggle.hidden = motion.matches;
      schedule();
    };
    const pause = () => { playing = false; render(); };
    const step = (delta) => { playing = false; index = (index + delta + slides.length) % slides.length; render(); };
    on(root.querySelector('[data-cs-prev]'), 'click', () => step(-1));
    on(root.querySelector('[data-cs-next]'), 'click', () => step(1));
    on(toggle, 'click', () => { playing = !playing && !motion.matches; render(); });
    on(root, 'focusin', (event) => { if (event.target !== toggle) pause(); });
    on(root, 'shopify:block:select', (event) => {
      const selected = slides.indexOf(event.target.closest('[data-cs-slide]'));
      if (selected >= 0) { index = selected; pause(); }
    });
    on(root, 'pointerdown', (event) => { if (event.target !== toggle) pause(); });
    on(root, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { hovered = true; schedule(); } });
    on(root, 'pointerleave', () => { hovered = false; schedule(); });
    on(surface, 'pointerdown', (event) => {
      suppressClick = false;
      if (event.button === 0) start = { x: event.clientX, y: event.clientY };
    });
    on(surface, 'pointerup', (event) => {
      if (!start) return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      start = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) { suppressClick = true; step(dx < 0 ? 1 : -1); }
    });
    on(surface, 'pointercancel', () => { start = null; });
    on(surface, 'click', (event) => {
      if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; }
    }, true);
    on(surface, 'dragstart', (event) => event.preventDefault());
    on(document, 'visibilitychange', schedule);
    const motionChanged = () => { if (motion.matches) playing = false; render(); };
    on(motion, 'change', motionChanged);
    const observer = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; schedule(); }, { threshold: 0.25 });
    root.classList.add('is-enhanced');
    controls.hidden = false;
    render();
    observer.observe(root);
    mounted.set(root, () => { clearTimeout(timer); observer.disconnect(); listeners.forEach(remove => remove()); mounted.delete(root); });
  };
  const init = (scope) => scope.querySelectorAll('[data-cs-carousel]').forEach(mount);
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-cs-carousel]').forEach(root => mounted.get(root)?.()));
})();
